import { render, staticRenderFns } from "./editMain.vue?vue&type=template&id=fd0de8f8&scoped=true&"
import script from "./editMain.vue?vue&type=script&lang=js&"
export * from "./editMain.vue?vue&type=script&lang=js&"
import style0 from "./editMain.vue?vue&type=style&index=0&id=fd0de8f8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd0de8f8",
  null
  
)

export default component.exports